import React, { useEffect, useState } from "react";
import Modal from "@zambezi/sdk/modal";

const MODAL_COUNTDOWN_MINUTES = 5; // 5 minutes

const LimitedTimeWarningModal = ({
  onConfirm,
  onSessionExpiry,
  shouldRender,
  isOpen,
}) => {
  const [countdownTimer, setCountdownTimer] = useState(null);
  const [countdownMinutes, setCountdownMinutes] = useState(
    MODAL_COUNTDOWN_MINUTES
  );
  const [isModalOpen, setModalOpenState] = useState(isOpen);

  const startCountdownTimer = () => {
    setCountdownTimer(
      setInterval(() => {
        setCountdownMinutes((countdownMinutes) => countdownMinutes - 1);
      }, 60 * 1000)
    );
  };

  // Monitor the number of minutes as the modal counts down from 5 minutes to 0
  useEffect(() => {
    if (countdownMinutes === 0) {
      clearInterval(countdownTimer);
      setModalOpenState(false);
      onSessionExpiry();
    }
  }, [countdownMinutes]);

  useEffect(() => {
    return () => {
      clearInterval(countdownTimer);
    };
  }, [shouldRender]);

  useEffect(() => {
    setModalOpenState(isOpen);
  }, [isOpen]);

  return (
    shouldRender && (
      <Modal
        title="Limited time remaining"
        confirm="Continue"
        open={isModalOpen}
        onOpen={startCountdownTimer}
        onConfirm={() => {
          setModalOpenState(false);
          onConfirm();
        }}
        isClosable={false}
      >
        <p>
          <strong>
            You have only 5 minutes remaining to complete and submit your form.
          </strong>
        </p>
        <p>
          You'll need to complete any requests within 56 minutes. If you're
          inactive for any longer than 14 minutes, we'll log you out for your
          own security.
        </p>
        <p>
          Be sure to tap the page or click your mouse every now and then to keep
          your page active, that way you won't loose any progress you've made.
        </p>
      </Modal>
    )
  );
};

export default LimitedTimeWarningModal;
